module.exports = __webpack_public_path__ + "img/refer_icon.e4523263.svg";